import { render, staticRenderFns } from "./OrmSendQuoteModal.vue?vue&type=template&id=50e561b7&scoped=true"
import script from "./OrmSendQuoteModal.vue?vue&type=script&lang=js"
export * from "./OrmSendQuoteModal.vue?vue&type=script&lang=js"
import style0 from "./OrmSendQuoteModal.vue?vue&type=style&index=0&id=50e561b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e561b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e561b7')) {
      api.createRecord('50e561b7', component.options)
    } else {
      api.reload('50e561b7', component.options)
    }
    module.hot.accept("./OrmSendQuoteModal.vue?vue&type=template&id=50e561b7&scoped=true", function () {
      api.rerender('50e561b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmSendQuoteModal.vue"
export default component.exports